var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9304 21.8115H10.0705C7.95134 21.8115 6.2334 23.5295 6.2334 25.6487V39.0786C6.2334 41.1978 7.95134 42.9157 10.0705 42.9157H36.9304C39.0496 42.9157 40.7676 41.1978 40.7676 39.0786V25.6487C40.7676 23.5295 39.0496 21.8115 36.9304 21.8115Z",
    stroke: "inherit",
    strokeWidth: 3.83713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9072 21.8099V14.1357C13.9048 11.7568 14.7865 9.46181 16.381 7.69635C17.9755 5.93088 20.1691 4.82087 22.536 4.58179C24.9029 4.34271 27.2742 4.99162 29.1895 6.40256C31.1049 7.81349 32.4276 9.88577 32.901 12.2171",
    stroke: "inherit",
    strokeWidth: 3.83713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.249a53e3e0ba2e71bd183127525324ec.svg";
export { ForwardRef as ReactComponent };